import { InteractionRequiredAuthError } from "@azure/msal-browser";

/**
 * Silent-only: never starts an interactive flow.
 * Returns access token string or null (if interaction required / no account).
 *
 * @param instance MSAL PublicClientApplication
 * @param account  MSAL account
 * @param scopes   Array of scopes, e.g. ["api://<client-id>/.default"]
 * @param forceRefresh If true, bypasses cached access tokens
 */
export async function getAccessToken(instance, account, scopes, forceRefresh = false) {
    if (!account) {
        return null;
    }

    const request = { scopes, account, forceRefresh };

    try {
        const result = await instance.acquireTokenSilent(request);
        return result.accessToken;
    } catch (error) {
        const interactionRequired =
            error instanceof InteractionRequiredAuthError ||
            error.errorCode === "interaction_required" ||
            error.errorCode === "invalid_grant";

        if (interactionRequired) {
            return null;
        }

        console.error("getAccessToken: unexpected error", error);
        throw error;
    }
}
